var AlertAction = /* @__PURE__ */ ((AlertAction2) => {
  AlertAction2["ACTIVE"] = "ACTIVE";
  AlertAction2["IN_ACTIVE"] = "IN_ACTIVE";
  return AlertAction2;
})(AlertAction || {});
export {
  AlertAction
};
//# sourceMappingURL=AlertAction.js.map
